export default __webpack_public_path__ + "static/media/invoice-template-1.971a7c57.png";